import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const slides = [{
  id: 1,
  image: 'https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&q=80&w=2000',
  alt: 'Fresh vegetables in a market'
}, {
  id: 2,
  image: 'https://images.unsplash.com/photo-1488459716781-31db52582fe9?auto=format&fit=crop&q=80&w=2000',
  alt: 'Market stalls with fresh produce'
}, {
  id: 3,
  image: 'https://images.unsplash.com/photo-1586528116311-ad8ed7c80a30?auto=format&fit=crop&q=80&w=2000',
  alt: 'Warehouse with supplies'
}];
export function Hero() {
  const [currentSlide, setCurrentSlide] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);
  return <section className="relative h-[80vh] min-h-[600px] w-full overflow-hidden bg-brand-navy mt-[88px]" data-id="element-104">
      <AnimatePresence mode="wait" data-id="element-105">
        <motion.img key={currentSlide} src={slides[currentSlide].image} alt={slides[currentSlide].alt} className="absolute inset-0 w-full h-full object-cover" initial={{
        opacity: 0,
        scale: 1.05
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeInOut'
      }} data-id="element-106" />
      </AnimatePresence>

      {/* Overlay */}
      <div className="absolute inset-0 bg-black/40" data-id="element-107" />

      {/* Content */}
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 z-10" data-id="element-108">
        <motion.h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 drop-shadow-lg max-w-4xl" initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.2,
        duration: 0.6
      }} data-id="element-109">
          Votre Partenaire en Approvisionnement
        </motion.h1>
        <motion.p className="text-xl md:text-2xl text-white mb-8 font-medium drop-shadow-md" initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.4,
        duration: 0.6
      }} data-id="element-110">
          Qualité et Prix Garantis !
        </motion.p>
        <motion.div initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.6,
        duration: 0.6
      }} data-id="element-111">
          <a href="#categories" className="bg-brand-green hover:bg-brand-green/90 text-white px-8 py-4 rounded-full font-semibold text-lg transition-all hover:scale-105 active:scale-95 shadow-lg flex items-center gap-2" data-id="element-112">
            Découvrir maintenant <span className="text-xl leading-none" data-id="element-113">»</span>
          </a>
        </motion.div>
      </div>

      {/* Slider Dots */}
      <div className="absolute bottom-8 left-0 right-0 flex justify-center gap-3 z-10" data-id="element-114">
        {slides.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`w-3 h-3 rounded-full transition-all ${currentSlide === index ? 'bg-brand-gold w-8' : 'bg-white/50 hover:bg-white/80'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-115" />)}
      </div>
    </section>;
}